import type {trpc} from "@/app/trpc";
import {BottomSheet} from "../layout";
import {BookingCard} from "../BookingCard";
import {ShadowBox, XStack, YStack} from "@chayka/ui";
import {NIGHT_HOURS} from "@chayka/utils";

interface BookingDetailsBottomSheetProps {
  booking: (typeof trpc.booking.list)["~types"]["output"][number];
  isOpen: boolean;
  onClose: () => void;
}

export const BookingDetailsBottomSheet: React.FC<BookingDetailsBottomSheetProps> = ({
  booking,
  isOpen,
  onClose,
}) => {
  const cards: (typeof trpc.booking.list)["~types"]["output"][number][] = [];

  for (const slot of booking.slots) {
    if (NIGHT_HOURS.includes(slot.hour) && booking.hasNightRoom) {
      if (cards.some((c) => c.slots.some((s) => NIGHT_HOURS.includes(s.hour)))) {
        continue;
      }
      const nightSlot = booking.slots.find((s) => NIGHT_HOURS.includes(s.hour));
      if (nightSlot) {
        cards.push({
          ...booking,
          slots: booking.slots.filter((s) => NIGHT_HOURS.includes(s.hour)),
          price: booking.slots
            .filter((s) => NIGHT_HOURS.includes(s.hour))
            .reduce((acc, s) => acc + s.price, 0),
        });
      }
    } else {
      cards.push({
        ...booking,
        slots: [slot],
        price: slot.price,
      });
    }
  }

  return (
    <BottomSheet fullHeight isOpen={isOpen} onClose={onClose}>
      <YStack className="gap-4">
        {booking.parkingModel && booking.parkingNumber && (
          <ShadowBox className="p-4 rounded-lg">
            <YStack className="gap-2">
              <div className="text-md font-bold">Авто</div>
              <YStack className="gap-1">
                <XStack className="gap-1 justify-between">
                  <div className="text-sm pr-3">Марка машины</div>
                  <div className="text-sm font-bold">{booking.parkingModel}</div>
                </XStack>
                <XStack className="gap-1 justify-between">
                  <div className="text-sm pr-3">Номер машины</div>
                  <div className="text-sm font-bold">{booking.parkingNumber}</div>
                </XStack>
              </YStack>
            </YStack>
          </ShadowBox>
        )}
        {booking.equipmentNames.length > 0 && (
          <ShadowBox className="p-4 rounded-lg">
            <YStack className="gap-2">
              <div className="text-md font-bold">Оборудование</div>
              <YStack className="gap-1">
                {booking.equipmentNames.map((name, i) => (
                  <XStack key={name} className="gap-1 justify-between">
                    <div className="text-sm pr-3">{name}</div>
                    <div className="text-sm font-bold">{booking.equipmentPrices[i]} ₽</div>
                  </XStack>
                ))}
              </YStack>
            </YStack>
          </ShadowBox>
        )}
        {cards.map((booking) => {
          if (!booking.slots[0]) {
            return null;
          }
          return (
            <BookingCard
              key={booking.date.toString() + booking.roomData?.id + booking.slots[0].hour}
              booking={booking}
              withMoreButton={false}
            />
          );
        })}
      </YStack>
    </BottomSheet>
  );
};
